import { FC } from 'react'
import iconModule from '@/assets/img/icons/dtp4.svg'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 25, height = 25 }) => {
  return (
    <img
      src={iconModule}
      alt='DTP'
      style={{ opacity: '0.65' }}
      width={width}
      height={height}
    />
  )
}

export default Icon
